import { derived } from 'svelte/store';
import { userInfo } from './user';
const resolveNameDefault = (personaName, namePostfix, dmpSegment, trackingPoint, ageGroups, gender, newDefaultInterests, interestOne, interestTwo, incomeGroups, lastSegmentId = 0, preview = false, mixed = false) => {
    if (preview) {
        return personaName.replace(/\s/g, '-').replace(/\+/g, 'plus');
    }
    else {
        return personaName.replace(/\s/g, '-').replace(/\+/g, 'plus') + '_' + namePostfix;
    }
};
const clientsWebData = [
    {
        name: 'demo',
        appTitle: 'AdPicker',
        logoSrc: '/assets/icons/android-chrome-512x512.png',
        logoWidth: '60%',
        primaryColor: '#ef4a50',
        secondaryColor: '#ef4a50',
        logoMarginTop: '16px',
        nameFunc: resolveNameDefault,
        nameEnd: '_demo',
        default: true,
        fee: false
    },
    {
        name: 'cpex',
        appTitle: 'CPEX',
        logoSrc: '/assets/images/clients/cpex.png',
        logoWidth: '60%',
        primaryColor: '#D82529',
        secondaryColor: '#191818',
        logoMarginTop: '16px',
        nameFunc: resolveNameDefault,
        nameEnd: '_cpex',
        default: true,
        fee: false
    },
    {
        name: 'vlm',
        appTitle: 'Vltava Labe Media',
        logoSrc: '/assets/images/clients/vlm.jpg',
        logoWidth: '100%',
        primaryColor: '#018CCF',
        secondaryColor: '#231F20',
        logoMarginTop: '16px',
        nameFunc: resolveNameDefault,
        nameEnd: '_vlm',
        default: true,
        fee: false
    },
    {
        name: 'eco',
        appTitle: 'ECO',
        logoSrc: '/assets/images/clients/eco.png',
        logoWidth: '100%',
        primaryColor: '#00386F',
        secondaryColor: '#009DE6',
        logoMarginTop: '16px',
        nameFunc: resolveNameDefault,
        nameEnd: '_eco',
        default: true,
        fee: false
    },
    {
        name: 'mafra',
        appTitle: 'MAFRA',
        logoSrc: '/assets/images/clients/mafra.png',
        logoWidth: '100%',
        primaryColor: '#ED1B2E',
        secondaryColor: '#77787B',
        logoMarginTop: '16px',
        nameFunc: resolveNameDefault,
        nameEnd: '_mafra',
        default: true,
        fee: false
    },
    {
        name: 'cnc',
        appTitle: 'Czech News Center',
        logoSrc: '/assets/images/clients/cnc.jpg',
        logoWidth: '100%',
        primaryColor: '#053484',
        secondaryColor: '#BDD800',
        logoMarginTop: '16px',
        nameFunc: resolveNameDefault,
        nameEnd: '_cnc',
        default: true,
        fee: false
    },
    {
        name: 'prima',
        appTitle: 'Prima',
        logoSrc: '/assets/images/clients/prima.png',
        logoWidth: '100%',
        primaryColor: '#ff8500',
        secondaryColor: '#3b3d42',
        logoMarginTop: '16px',
        nameFunc: resolveNameDefault,
        nameEnd: '_prima',
        default: true,
        fee: false
    },
    {
        name: 'dentsu',
        appTitle: 'Dentsu CZ',
        logoSrc: '/assets/images/clients/dentsu_logo.svg',
        logoWidth: '90%',
        primaryColor: '#66548F',
        secondaryColor: '#8e9197',
        logoMarginTop: '16px',
        nameFunc: resolveNameDefault,
        nameEnd: '_dentsu',
        default: true,
        fee: false
    },
];
const userClientData = derived(userInfo, ($user) => {
    const webData = $user.client
        ? clientsWebData.find((item) => item.name === $user.client.label) || clientsWebData[0]
        : clientsWebData[0];
    return {
        client: $user.client,
        webData
    };
});
export { userClientData };
